export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_MENU = 'OPEN_MENU';
export const GO_TO_NEXT_ITEM = 'GO_TO_NEXT_ITEM';
export const GO_TO_PREV_ITEM = 'GO_TO_PREV_ITEM';
export const GO_TO_ITEM = 'GO_TO_ITEM';
export const REGISTER_ITEM = 'REGISTER_ITEM';
export const UNREGISTER_ITEM = 'UNREGISTER_ITEM';
export const SET_NAVIGATING_WITH_KEYBOARD = 'SET_NAVIGATING_WITH_KEYBOARD';
//# sourceMappingURL=constants.js.map